import React, { useContext, useMemo } from "react";
import RightSizingTable from "./rightsizing-table.part";
import styles from "@/page-components/RightSizing/rightSizing.module.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import downlaodVM from "@/assets/img/downloadVM.svg";
import FilterSection from "./filtersection/recom-filtersection";
import { useRecommendationsListDownload } from "@/services/rightRecommendation/recomm-list-download.repo";
import { RiContexts } from "../right.context";

const RightSizing = ({service,name}) => {

  const context = useContext(RiContexts);
    const downloadQuery = useMemo(() => {
      return {
        service,
      };
    }, [service]);
  
    const { mutate: downloadMutate } =
      useRecommendationsListDownload(downloadQuery);
  const handleDownloadClick = () => {
    downloadMutate(downloadQuery);
  };

  return (
    <div className={styles.tablesFilterDiv}>
      <div className={styles.tableDiv1}>
        <span
          className={styles.recommendationsLabel}
          style={{ display: "flex", justifyContent: "space-between" }}
          >
          Rightsizing Recommendations
          {context?.totalValue?.total > 0 &&(
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip">Download as CSV</Tooltip>}
          >
            <span
              className={styles.downloadButton}
              onClick={handleDownloadClick}
            >
              <img src={downlaodVM} alt="" />
            </span>
          </OverlayTrigger>
        )}
        </span>
        <p className={styles.recommendationsText}>
          Explore In-Depth Recommendations for VM Right Sizing and Insights into
          Resource Utilization. Unlock EconomiQ Potential by Aligning
          Infrastructure with Actual Workload Demands. Delve into Actionable
          Data for Informed Decision-Making and Efficient Resource Allocation.
        </p>
        <div style={{ display: "flex" }}>
          <RightSizingTable
            service={service}
            name={name}
            resource="ResourceId"
          />
        </div>
      </div>
      <FilterSection service={service} name={name} />
    </div>
  );
};

export default RightSizing;
